export default __webpack_public_path__ + "static/media/330_portfolio03-en-mobile.7685ee7a.png";